<template>
  <div class="con" style="position: relative">
    <div class="topHeader">
      <img src="/static/img/index/back.png" alt="" class="backImg" @click="goBack" />
      <div class="title">经典钥匙</div>
    </div>

    <!-- <img src="/static/img/index/back.png" alt="" class="backImg" @click="goBackCenter" /> -->
    <div class="content">
      <div style="padding-bottom: 128px;">
        <openBoxSwiperApp :data="packList" @toDetail="openModal"></openBoxSwiperApp>
      </div>
      <div class="openBoxFooterDiv" v-if="packList.length&&packList[0].showspace">
        <div class="btn btn2" @click="goBackCenter">查看全部藏品</div>
        <div class="btn btn1" @click="goMusicHome">进入音乐空间</div>
      </div>
      <div class="openBoxFooterDiv ccenter" v-else>
        <div class="btn btn1" @click="goBackCenter">查看全部藏品</div>
      </div>
    </div>

  </div>
</template>

<script>
  let Base64 = require("js-base64").Base64;
  import openBoxSwiperApp from "@/components/openBoxSwiperApp";
  export default {
    components: {
      openBoxSwiperApp,
    },
    name: "getBox",
    // components: {
    // },
    data() {
      return {
        base: Base64.decode(this.$store.state.token.split(".")[1]),
        isLength1: true,
        packList: [], //盲盒下的作品列表
        attrsid: "",
        boxLength: 0,
        list: [],
        opusattrid: "",
        isInApp: false,
      };
    },
    computed: {},
    methods: {
      goMusicHome() {
        if (this.isInApp) {
          // 获取app token
          this.$bridge.callhandler("getUserToken", {}, (token) => {
            if (token) {
              this.$store.setstate.token(token);
              this.$bridge.callhandler("toMusicSpace", {}, (appRes) => {});
            } else {
              this.$store.setstate.token('')
              this.$bridge.callhandler("getLogin", {}, (token) => {});
            }
          });
        }
      },
      goBackCenter() {
        if (this.isInApp) {
          // 获取app token
          this.$bridge.callhandler("getUserToken", {}, (token) => {
            if (token) {
              this.$store.setstate.token(token);
              this.$bridge.callhandler("toMineOpus", {}, (appRes) => {});
            } else {
              this.$store.setstate.token('')
              this.$bridge.callhandler("getLogin", {}, (token) => {});
            }
          });
        }
      },
      //底部按钮  返回个人中心 或者返回上一页
      goBack() {
        if (this.isInApp) {
          this.$bridge.callhandler("onClose", {}, (token) => {});
        }
      },
      openModal(item) {
        if (this.isInApp) {
          // 获取app token
          this.$bridge.callhandler("getUserToken", {}, (token) => {
            if (token) {
              this.$store.setstate.token(token);
              var code = JSON.stringify({
                id: item.id,
                code: 0,
                opusattrid: item.opusattrid,
              });
              this.$bridge.callhandler("getOpenOpus", code, (appRes) => {});
            } else {
              this.$store.setstate.token('')
              this.$bridge.callhandler("getLogin", {}, (token) => {});
            }
          });
        }
      },


      // 处理作品显示
      showPackDetail(data) {
        let that = this;
        this.$loading.hide();

        if (data.length) {
          data.forEach(item => {
            that.packList.push({
              id: item.opusId,
              workIntroSub: item.seriesName,
              workName: item.opusName,
              workCode: '',
              workIntro: '',
              qty: '',
              imgurl: this.$baseUrl + item.image,
              attrsid: '',
              opusattrid: item.opusAttrId,
              opustag: [],
              showspace: item.showspace,
            });
          })
        }
      },
      getDataAll() {
        let that = this;
        this.$loading.show();
        that.$fetchql
          .Post("opus/goods/order/show", {
            orderno: that.$route.query.orderno,
          })
          .then((res) => {
            that.showPackDetail(res.data)
          });
      },
    },
    mounted() {
      this.getDataAll();
      //判断是否在app内部打开
      let u = navigator.userAgent
      if (u.indexOf('mints') != -1) {
        this.$bridge.callhandler("hideNavigationBar", {}, (res) => {})
        this.$bridge.callhandler("inApp", "", (res) => {
          this.isInApp = res;
          if (this.isInApp) {
            this.$bridge.callhandler("getUserToken", {}, (token) => {
              if (token) {
                this.$store.setstate.token(token);
              } else {
                this.$store.setstate.token("");
                this.$bridge.callhandler("getLogin", {}, (token) => {});
              }
            });
          }
        });
      }
    },
  };

</script>

<style scoped="scoped" lang="less">
  .con {
    position: relative;
    min-height: 100vh;
    background: url('/static/img/work/openBoxBg.png');
    background-size: 100% 100%;
  }

  .content {
    padding-top: 244px;
    padding-left: 14px;
    padding-right: 14px;
  }

  .topHeader {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 9;
    height: 94px;
    background: #000;

    .backImg {
      width: 21px;
      height: 9px;
      display: inline-block;
      vertical-align: middle;
      position: absolute;
      left: 15px;
      top: 59px;
    }

    .title {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      display: inline-block;
      width: 100%;
      margin-top: 56px;
    }

  }


  .backImg {
    position: fixed;
    top: 25px;
    left: 15px;
    width: 21px;
    height: 9px;
    z-index: 2;
  }

  .topOne {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 13px;
    padding-bottom: 7px;
    border-bottom: 1px solid #333;
  }

  .title {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
  }

  .intro {
    display: inline-block;
    font-size: 10px;
    color: #fff;
    margin-left: 10px;
    /* padding: 8px 0 14px 0px;
    border-bottom: 1px solid #4f5161;
    color: #f5f4f9;
    font-size: 14px;
    margin-bottom: 40px; */
  }

  .list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 56px;
    /* display: flex; */
    text-align: left;
    padding-bottom: 58px;
  }

  .listView {
    position: relative;
    width: 136px;
    /* margin-bottom: 58px; */
    /* height: 124px; */
    display: inline-block;
    /* flex: 1; */
  }

  .listView:nth-child(even) {
    margin-left: 47px;
  }

  .listFlex {
    display: block;
    text-align: center;
    margin-top: 25px;

    .listView {
      width: 204px;
    }

    .lookText {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      margin-top: 80px;
      left: 30px;
    }

    .bgImg {
      width: 204px;
    }
  }

  .bgImg {
    width: 132px;
    /* height: 124px; */
  }

  .lookText {
    position: absolute;
    color: #f5f4f9;
    font-size: 14px;
    margin-top: 45px;
    margin-left: 37px;
    font-weight: bold;
    text-shadow: 0px 0px 17px rgba(255, 255, 255, 0.5);
  }

  .list {
    padding-left: 19px;
    padding-right: 19px;
  }

  .list .listTitle {
    color: #fff;
    font-size: 14px;
    margin-top: 10px;
  }

  .list .Des {
    color: #c7c7d3;
    font-size: 10px;
    line-height: 15px;
    margin-top: 5px;
    margin-bottom: 10px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .list .No {
    border: 1px solid #1ce89e;
    color: #1ce89e;
    font-size: 10px;
    padding: 2px 8px;
    display: inline-block;
  }

  .showModal {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: #1a1f1e;
    z-index: 2;
  }

  .showModal .logoImg {
    width: 96px;
    // height: 24px;
    margin-top: 12px;
  }

  .showModal .closeImg {
    width: 24px;
    height: 24px;
    float: right;
    margin-top: 12px;
  }

  .showModal .top {
    height: 56px;
    padding: 0 16px;
  }

  .showModal .mainImg img,
  .showModal .mainImg video {
    width: 100%;
    height: 216px;
    margin-bottom: 16px;
  }

  .showModal .label {
    border: 1px solid #4bcfaf;
    border-radius: 4px;
    color: #4bcfaf;
    font-size: 14px;
    font-weight: bold;
    padding: 4px 8px;
    float: right;
    margin-right: 16px;
    margin-top: 12px;
  }

  .showModal .name {
    margin: 8px auto 27px auto;
    color: #f5f4f9;
    font-size: 24px;
    font-weight: bold;
    padding-left: 16px;
    padding-right: 16px;
  }

  .showModal .name img {
    width: 96px;
    height: 9px;
    display: block;
    object-fit: cover;
    margin-top: 8px;
  }

  .introDuce {
    padding-left: 16px;
    padding-right: 16px;
  }

  .introDuce .duce {
    margin-bottom: 14px;
  }

  .introDuce .describe {
    color: #f5f4f9;
    font-size: 14px;
    line-height: 24.5px;
  }

  .introDuce .duce .left {
    width: 76px;
    color: #8d8f9f;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
  }

  .introDuce .duce .right {
    display: inline-block;
    font-size: 16px;
    color: #f5f4f9;
  }

  @keyframes rotate1 {
    24% {
      transform: rotateY(-240deg);
    }

    54% {
      transform: rotateY(-360deg);
    }

    80% {
      transform: scale(1, 1);
    }

    100% {
      transform: rotateY(-360deg);
      transform: scale(1.5, 1.5);
    }
  }

  .stage {
    width: 176px;
    height: 162px;
    perspective: 600px;
    transform: translate(-50%, -50%);
    margin: 150px auto 0 155px;
  }

  .cube {
    width: 100%;
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    transition: transform 1s ease-in-out;
    animation: rotate1 4s 1 linear;
  }

  .cube-face {
    position: absolute;
    width: 178px;
    height: 164px;
    border-radius: 10px;
    background-size: 100%;
    transform: rotate3d(0, 1, 0, 360deg);
  }

  .cfront {
    transform: rotateY(0deg) translateZ(85px);
    background-size: cover;
    background-position: center;
  }

  .cfront img {
    height: 216px;
  }

  .cback {
    transform: rotateY(180deg) translateZ(85px);
    background-image: url("/static/img/box-pattern1@2x.png");
    background-size: cover;
    background-position: center;
  }

  .ctop {
    transform: rotateX(90deg) translateZ(85px);
    background-image: url("/static/img/box-pattern1@2x.png");
    background-size: 100%;
  }

  .cright {
    transform: rotateY(90deg) translateZ(85px);
    background-image: url("/static/img/box-pattern@2x.png");
  }

  .cbottom {
    transform: rotateX(-90deg) translateZ(85px);
    background-image: url("/static/img/box-pattern1@2x.png");
    background-size: 100%;
  }

  .cleft {
    transform: rotateY(-90deg) translateZ(85px);
    background-image: url("/static/img/box-pattern@2x.png");
  }

  .openBoxFooterDiv {
    width: 100%;
    height: 40px;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    bottom: 50px;
    left: 0%;
    z-index: 9;
    box-sizing: border-box;
    padding: 0 25px;

    &.ccenter {
      justify-content: center;
    }

    .btn {
      width: 159px;
      height: 40px;
      line-height: 40px;
      text-align: center;

      &.btn1 {
        background: url(/static/img/openBox/btn1.png);
        background-size: 100% 100%;
        font-size: 15px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #000000;
      }

      &.btn2 {
        background: url(/static/img/openBox/btn2.png);
        background-size: 100% 100%;
        font-size: 15px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #1CE89E;
      }
    }
  }





  .mutedImg {
    width: 29px !important;
    height: 29px !important;
    position: absolute !important;
    top: 230px;
    left: 10px !important;
    z-index: 9999 !important;
  }

  .fullscreenImg {
    position: absolute !important;
    right: 10px !important;
    height: 29px !important;
    top: 230px;
    width: 29px !important;
    z-index: 9999 !important;
  }

  .downloadImg {
    position: absolute;
    right: 40px;
    top: 230px;
    width: 29px !important;
    height: 29px !important;
    z-index: 9999;
    background: url(/static/img/sellingTime/download.png);
    background-size: 100% 100%;
  }

  .video-box {
    /* width: 100%;
    height: 100%; */
    position: relative;
    /* border-radius: 14px; */
    overflow: hidden;
    font-size: 0;
    width: 100% !important;
    height: 210px !important;
    z-index: -1 !important;
  }

  /deep/ #J_prismPlayer {
    text-align: center !important;
  }

  /deep/ .prism-player video {
    width: auto !important;
    position: static !important;
    left: 0 !important;
    top: 0 !important;
    transform: translate(0%, 0%) !important;
    object-position: 50% 50% !important;
    object-fit: contain;
  }

</style>
<style>
  .prism-player .prism-cover {
    background-size: contain;
  }

</style>



// WEBPACK FOOTER //
// src/views/appModel/openBox.vue